export default "/_next/static/images/product_messages-7b8d80d4cbbbc54baad14b47d1eff46f.svg";